if (!customElements.get('athlean-video-stories')) {
    customElements.define('athlean-video-stories', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.track = this.querySelector('[data-avs-track]');
        this.cards = [...this.querySelectorAll('[data-avs-card]')];
        this.dialog = this.querySelector('dialog');
        this.player = this.querySelector('[data-avs-player]');
        this.navigation = this.querySelector('[data-avs-navigation]');
        this.previous = this.querySelector('[data-avs-prev]');
        this.next = this.querySelector('[data-avs-next]');
        this.addEventListener('click', (event) => {
          const open = event.target.closest('[data-avs-open]');
          if (open && this.contains(open)) this.openVideo(open);
          if (event.target.closest('[data-avs-close]')) this.dialog.close();
          if (event.target.closest('[data-avs-prev]')) this.move(-1);
          if (event.target.closest('[data-avs-next]')) this.move(1);
        }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => this.stopVideo(), { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateControls());
        }, { signal, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !this.isSlider()) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-avs-card]');
          if (card && this.isSlider()) this.scrollToCard(this.cards.indexOf(card), 'auto');
        }, { signal });
        this.observer = new ResizeObserver(() => this.updateControls());
        this.observer.observe(this.track);
        this.updateControls();
      }
      disconnectedCallback() {
        this.stopVideo();
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      isSlider() { return getComputedStyle(this.track).display === 'flex'; }
      currentIndex() {
        const bounds = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let best = 0, distance = Infinity;
        this.cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const delta = Math.abs(rtl ? bounds.right - rect.right : rect.left - bounds.left);
          if (delta < distance) { distance = delta; best = index; }
        });
        return best;
      }
      visibleCount() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const width = this.cards[0]?.getBoundingClientRect().width || this.track.clientWidth;
        return Math.max(1, Math.round((this.track.clientWidth + gap) / (width + gap)));
      }
      scrollToCard(index, behavior) {
        const card = this.cards[index];
        if (!card) return;
        const bounds = this.track.getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: rtl ? rect.right - bounds.right : rect.left - bounds.left, behavior });
      }
      move(direction) {
        const last = Math.max(0, this.cards.length - this.visibleCount());
        const index = Math.max(0, Math.min(last, this.currentIndex() + direction));
        this.scrollToCard(index, matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
      }
      updateControls() {
        const count = this.visibleCount();
        const last = Math.max(0, this.cards.length - count);
        const index = Math.min(last, this.currentIndex());
        this.navigation.hidden = !this.isSlider() || last === 0;
        this.previous.disabled = index === 0;
        this.next.disabled = index >= last;
        this.querySelector('[data-avs-count]').textContent = `${index + 1} / ${last + 1}`;
      }
      openVideo(button) {
        const template = button.closest('[data-avs-card]').querySelector('[data-avs-video]');
        if (!template || this.dialog.open) return;
        document.querySelectorAll('athlean-video-stories').forEach((section) => {
          if (section !== this && section.dialog?.open) section.dialog.close();
        });
        this.opener = button;
        this.querySelector('[data-avs-dialog-title]').textContent = button.dataset.avsTitle;
        this.player.replaceChildren(template.content.cloneNode(true));
        this.dialog.showModal();
        this.querySelector('[data-avs-close]').focus();
        // No video exists in the active page until the customer clicks a card.
        const video = this.player.querySelector('video');
        if (video) {
          video.autoplay = false;
          video.muted = false;
          video.setAttribute('aria-label', button.dataset.avsTitle);
          const playback = video.play();
          playback?.catch(() => { /* Native controls remain available if playback is blocked. */ });
        }
      }
      stopVideo() {
        this.player?.querySelectorAll('video').forEach((video) => video.pause());
        this.player?.replaceChildren();
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      }
    });
  }
